import { render, staticRenderFns } from "./SimpleSearch.vue?vue&type=template&id=08706304&scoped=true"
import script from "./SimpleSearch.vue?vue&type=script&lang=js"
export * from "./SimpleSearch.vue?vue&type=script&lang=js"
import style0 from "./SimpleSearch.vue?vue&type=style&index=0&id=08706304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08706304",
  null
  
)

export default component.exports